<div
	class="dialog-header sl-flexbox-row sl-flexbox-align-center"
	mat-dialog-title>
	<span
		class="dialog-title"
		[innerHtml]="title"></span>
</div>
<div
	class="sl-fancy-scroll"
	mat-dialog-content>
	<div
		class="content-wrapper"
		[innerHtml]="content"></div>
</div>
<div
	class="sl-flexbox-row sl-flexbox-justify-end sl-flexbox-align-center"
	mat-dialog-actions>
	<sl-text-button
		label="Close"
		mat-dialog-close></sl-text-button>
</div>
